import { NavLink } from 'react-router';
import { strings } from '@/theme';
import { Icon } from '../ui';

// Labels come from src/theme/strings.ts, the same copy the app's tab bar uses — and the same two
// tabs: Discover is switched off for now on both clients (/discover redirects to Build).
const TABS = [
  { to: '/', icon: 'build', activeIcon: 'buildActive', label: strings.tabs.build },
  { to: '/my-apps', icon: 'myApps', activeIcon: 'myAppsActive', label: strings.tabs.myApps },
] as const;

/** One component, two layouts: a bottom bar on phones, a left rail from 768px, in CSS. */
export default function TabBar() {
  return (
    <nav aria-label="Main" className="tabbar glass">
      {TABS.map((t) => (
        <NavLink key={t.to} to={t.to} end={t.to === '/'} className="tab">
          {({ isActive }) => (
            <>
              <Icon name={isActive ? t.activeIcon : t.icon} size={24} color={isActive ? 'var(--color-primary)' : 'var(--color-text-muted)'} />
              <span className="type-micro">{t.label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
